import React from 'react';

function Home() {
  return (
    <div>
      <h1>Welcome to the Poker Game</h1>
    </div>
  );
}

export default Home;
